import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { toast } from "sonner";
import { useAuthedApi } from "../../lib/api";
import { useFavorites } from "../../lib/favorites";
import { Switch } from "../ui/switch";
import CarCard from "../CarCard";

function PriceAlertToggle() {
  const api = useAuthedApi();
  const [me, setMe] = useState(null);
  useEffect(() => { api("get", "/me").then(setMe); }, [api]);
  if (!me) return null;
  const toggle = async (on) => {
    setMe({ ...me, price_alerts_off: !on });
    try { await api("put", "/me/price-alerts", { enabled: on }); toast.success(on ? "Price drop alerts on" : "Price drop alerts off"); }
    catch { setMe({ ...me, price_alerts_off: on }); toast.error("Could not update"); }
  };
  return (
    <label className="lux-card p-3 mb-4 flex items-center justify-between gap-4 cursor-pointer max-w-xl" data-testid="price-alerts-toggle-row">
      <span className="text-sm"><span className="font-semibold block">Email me when a saved car drops in price</span><span className="text-gray-400 text-xs">Sent to {me.email || "your account email"}</span></span>
      <Switch className="data-[state=unchecked]:bg-gray-600" checked={!me.price_alerts_off} onCheckedChange={toggle} data-testid="price-alerts-toggle" />
    </label>
  );
}

export default function SavedCars() {
  const api = useAuthedApi();
  const { ids } = useFavorites();
  const [items, setItems] = useState(null);
  useEffect(() => { api("get", "/favorites").then((r) => setItems(r.items)); }, [api]);

  if (!items) return <p className="text-gray-500">Loading...</p>;
  const shown = items.filter((c) => ids.has(c.id));
  return (
    <div>
      <PriceAlertToggle />
      {!shown.length ? (
        <div className="lux-card p-12 text-center text-gray-400" data-testid="no-saved">No saved cars yet. Tap the heart on any car to save it. <Link to="/cars" className="text-[#E5C158]">Browse cars</Link></div>
      ) : (
        <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-3" data-testid="saved-cars">{shown.map((c, i) => <CarCard key={c.id} car={c} index={i} />)}</div>
      )}
    </div>
  );
}
